import { AfterViewInit, Component, inject, OnInit, output, signal, viewChild, } from '@angular/core';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { FormsModule } from '@angular/forms';
import { AbcAccordionComponent, AbcPopupComponent, _AbcButtonComponent, _AbcScrollViewComponent, _AbcSelectBoxComponent } from '@barthauer/abc/ui-components';
import { DxButtonModule, DxDataGridModule, DxFormModule, DxTemplateModule } from 'devextreme-angular';
import { DxiItemModule } from 'devextreme-angular/ui/nested';
import { first } from 'rxjs';
import { DataService } from '../../services/data.service';
import { PermissionService } from '../../services/permission.service';
import { PERMISSION_STRUCTURE } from '../permission-structure';
import { UserRightPopupService } from './user-right-popup.service';
import { ToastType } from '@barthauer/custom/xmt-models';
import { NotificationService } from '../../services/notification.service';
import { UbtLoaderComponent } from '../../shared/ubt-loader/ubt-loader.component';
import { DxButtonTypes } from 'devextreme-angular/ui/button';
import { UserRolePermissionViewModel } from '../../view-models/user-role-permission.view-model';
import { ValueChangedEvent } from 'devextreme/ui/select_box';

@Component({
  selector: 'ubt-user-right-popup',
  templateUrl: './user-right-popup.component.html',
  styleUrls: ['./user-right-popup.component.scss'],
  imports: [
    FlexLayoutModule,
    _AbcButtonComponent,
    AbcPopupComponent,
    DxDataGridModule,
    DxTemplateModule,
    DxFormModule,
    AbcPopupComponent,
    FormsModule,
    DxiItemModule,
    DxButtonModule,
    DxiItemModule,
    _AbcScrollViewComponent,
    DxDataGridModule,
    AbcAccordionComponent,
    _AbcSelectBoxComponent,
    UbtLoaderComponent
  ],
  providers: [
    UserRightPopupService
  ]
})
export class UserRightPopupComponent implements OnInit,AfterViewInit {
  private readonly userRightPopupService = inject(UserRightPopupService);
  private readonly dataService = inject(DataService);
  private readonly permissionService = inject(PermissionService);
  private readonly notificationService = inject(NotificationService);
  
  protected closePopup =  output<boolean>();
  
  private userRightsPopup = viewChild<AbcPopupComponent>('userRightsPopup')
  
  protected title= '';
  protected res: (key: string, ...value: string[]) => string = this.dataService.res;
  protected updateButtonOptions : DxButtonTypes.Properties = {
    text: this.res('Ubt-CreateMeasure-Update'),
    useSubmitBehavior: true,
  };
  protected modules = signal(PERMISSION_STRUCTURE);
  protected showLoader = false;
  protected dataSource:{value:boolean, displayText:string}[] = [
    { value: true, displayText: 'Yes' },
    { value: false, displayText: 'No' }
  ]
  protected actions : string[] = this.userRightPopupService.actions
  protected isLoading=signal(false);

  ngOnInit():void{
    this.loadPermissions();
  }
  ngAfterViewInit():void{
    this.openUserPopup();
  }
  protected saveChanges() :void {
    this.userRightPopupService.persistUserRolePermissions().pipe(first()).subscribe({
      complete:()=>{
        this.notificationService.callNotification(
        {
          message: this.dataService.res('Ubt-Permession-Update-Message'),
          type: ToastType.SUCCESS,
        })
        this.closePopUp();
      },
      error:()=>this.notificationService.callNotification(
        {
          message: this.dataService.res('Ubt-Permession-Update-Error-Message'),
          type: ToastType.ERROR,
        })
    });
  }

  protected closePopUp() :void {
    this.userRightsPopup().instance.hide()
    this.permissionService.setRole(undefined);
    this.closePopup.emit(false);
  }
  protected onPermissionChange(event:ValueChangedEvent,module: UserRolePermissionViewModel,action:string): void {
    if(!event.event) return;
    if(this.userRightPopupService.verifyActivePermission(module)){
      this.userRightPopupService.synchronizePermissions(module,action);
      this.modules.update(module=>module);
    }else this.userRightPopupService.updateModulesMap(module,action);
  }
  private loadPermissions() : void {
    this.isLoading.set(true);
    this.userRightPopupService.loadPermissions().pipe(first())
     .subscribe({
        next: ({modules,description}) => {
          this.title=description
            ? `${this.res('Ubt-User-Rights')}: ${description}`
            : this.res('Ubt-Settings-Popup');
          this.modules.set(this.userRightPopupService.mergeModules(PERMISSION_STRUCTURE, modules));
          this.userRightPopupService.buildModulesMap(this.modules());
          this.isLoading.set(false);
        },
        error:()=>{this.notificationService.callNotification(
          {
            message: this.dataService.res('Ubt-User-Rights-Load-Permission-Error'),
            type: ToastType.ERROR,
          })
          this.isLoading.set(false);
        }
      })
  }

  private openUserPopup() : void {
    this.userRightsPopup()?.instance.show();
  }
}